import signedFetch from './util/signedFetch.js';

export default body =>
  signedFetch(
    'getLicenceDetails',
    `${__API_BASE__}/admin-console/activationCode/search?${body.pagination}`,
    'POST',
    body
  );
